import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PeopleService} from '../../services/people/people.service';
import {ToastNotificationService} from '../../services/toast-notification/toast-notification.service';

@Component({
    selector: 'ngx-replace-profile-image-button',
    templateUrl: './replace-profile-image-button.component.html',
    styleUrls: ['./replace-profile-image-button.component.scss']
})
export class ReplaceProfileImageButtonComponent implements OnInit {
    @Input('id') id; // Id of the child/person to replace profile image of
    @Input('buttonText') buttonText = 'Upload';

    @Output() onSuccess: EventEmitter<string> = new EventEmitter();

    @ViewChild('file') fileInput;
    public profilePhoto: string;
    public file: any;
    public uploading: boolean = false;

    constructor(
        private cd: ChangeDetectorRef,
        private people: PeopleService,
        private toaster: ToastNotificationService,
    ) {
    }

    ngOnInit() {
    }

    uploadPhoto() {
        this.fileInput.nativeElement.click();
    }

    onFileChange(event) {
        const vm = this;
        vm.uploading = true;
        if (event.target.files && event.target.files.length) {
            const files = event.target.files;
            const file = files[0];
            const reader = new FileReader();

            vm.file = file;
            reader.readAsDataURL(file);
            reader.onload = () => {
                vm.profilePhoto = reader.result;
                vm.cd.markForCheck();
                vm.changeProfilePicture().then(() => {
                    vm.uploading = false;
                }).catch(() => {
                    vm.uploading = false;
                });
            };
        }
    }

    changeProfilePicture() {
        const vm = this;
        return new Promise((resolve, reject) => {
            if (vm.file) {
                const request = vm.people.changeProfilePicture(vm.id, vm.file);
                vm.toaster.handleResponse(request, (status, error) => error, 'Upload afbeelding succes');
                request.then(data => {
                    console.log(data);
                    this.onSuccess.emit(data['data']);
                    resolve();
                })
                    .catch(() => {reject()})
                ;
            }else {
                reject();
            }
        });
    }

}
